import { Fragment, useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Grid } from "@mui/material";
import { FormControl, FormLabel, Input } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { PhoneInput } from "react-international-phone";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { InputTextarea } from "primereact/inputtextarea";
import S3DocumentsUpload from "../../components/S3DocumentsUpload";
import { updateEmployee } from "../../service/employeeService";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import ImageS3Upload from "../../components/ImageS3Upload";
import SubContractorSiteTable from "./SubContractor-Site-table";
import { placeholder } from "../../assets/placeholder";
import { InputIcon } from "primereact/inputicon";
import { LogsLookup } from "../../service/clientService";
import { updateSubContractor } from "../../service/subContractorService";

export default function SubContractorView(props: RouteComponentProps) {
  const subContractor = props.subContractor || {};

  const [name, setName] = useState(subContractor?.name || "");

  const [ceoName, setCeoName] = useState(subContractor?.ceo_name || "");
  const [ceoSurname, setCeoSurname] = useState(subContractor?.ceo_surname || "");
  const [ceoEmail, setCeoEmail] = useState(subContractor?.ceo_email || "");
  const [ceoMobile, setCeoMobile] = useState(subContractor?.ceo_mobile || "");

  const [managerName, setManagerName] = useState(subContractor?.manager_name || "");
  const [managerSurname, setManagerSurname] = useState(subContractor?.manager_surname || "");
  const [managerEmail, setManagerEmail] = useState(subContractor?.manager_email || "");
  const [managerMobile, setManagerMobile] = useState(subContractor?.manager_mobile || "");

  const [scopeOfWork, setScopeOfWork] = useState(subContractor?.scope_of_work || "");

  const [appointment, setAppointment] = useState(subContractor?.appointment || "");

  const [vatRegistration, setVatRegistration] = useState(
    subContractor?.vat_registration_number || ""
  );
  const [companyRegistration, setCompanyRegistration] = useState(
    subContractor?.company_registration_number || ""
  );
  const [fundRegistration, setFundRegistration] = useState(
    subContractor?.fund_registration_number || ""
  );

  const [fundShowValidation, setFundShowValidation] = useState(false);
  const [fundIdError, setFundIdError] = useState(false);
  const [fundIdLoader, setFundIdLoader] = useState(false);

  const [certificateNumber, setCertificateNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [issueDate, setIdIssueDate] = useState("");
  const [tradeName, setTradeName] = useState("");

  const [userId, setUserId] = useState(subContractor?.user_id || "");
  const [photo, setPhoto] = useState(subContractor?.photo || placeholder);
  const [file, setFile] = useState<File>();
  const [activeStep, setActiveStep] = useState(0);

  const toast = useRef(null as any);

  const session = props?.session || {};

  const clientId = session.client_id;
  const s3Key = subContractor?.s3_key || `sub-contractor/${subContractor.id}`;

  console.log("appointment", appointment);

  // useEffect(() => {
  //   setUpdateS3Key();
  // }, [file]);

  // validID

  async function setUpdateS3Key() {
    updateEmployee(
      {
        s3_key: s3Key,
      },
      subContractor.id
    ).then((r: any) => {});
  }

  async function LogsVerifyID() {
    if (!fundRegistration) return;
    setFundIdLoader(true);
    setFundShowValidation(true);
    LogsLookup(fundRegistration)
      .then((r: any) => {
        console.log("LogsVerifyID r == ", r);
        setFundIdLoader(false);
        if (!r?.certificateNumber) {
          setFundIdError(true);
          return;
        }
        setCertificateNumber(r.certificateNumber);
        setExpiryDate(r.expiryDate);
        setIdIssueDate(r.issueDate);
        setTradeName(r.tradeName);
        setFundIdError(false);
      })
      .catch(error => {
        setFundIdLoader(false);
        setFundIdError(true);
      });
  }

  async function updateSub() {
    const updateObject = {
      name,
      ceo_name: ceoName,
      ceo_surname: ceoSurname,
      ceo_email: ceoEmail,
      ceo_mobile: ceoMobile,
      manager_name: managerName,
      manager_surname: managerSurname,
      manager_email: managerEmail,
      manager_mobile: managerMobile,
      user_id: userId,
      s3_key: !!file ? `sub-contractor/${id}` : undefined,
      fund_registration_number: fundRegistration,
      vat_registration_number: vatRegistration,
      company_registration_number: companyRegistration,
      scope_of_work: scopeOfWork,
      appointment,
    };
    updateSubContractor(updateObject, subContractor.id).then((r: any) => {
      toast.current.show({
        severity: "success",
        summary: "Sub Contractor Updated Successfully",
        life: 3000,
      });
    });
  }

  const record_id = subContractor.id || "";

  const id = subContractor.id || "";

  return (
    <Fragment>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          type="button"
          icon="pi pi-save"
          label="Save"
          className="p-button-outlined"
          size="small"
          style={{ color: "#2dd36f" }}
          onClick={() => updateSub()}
        />
      </div>
      <TabView>
        <TabPanel header="Details">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <FormControl>
                  <ImageS3Upload
                    photo={photo}
                    setPhoto={setPhoto}
                    s3Key={`sub-contractor/${id}`}
                    file={file}
                    setFile={setFile}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={8}>
                <Grid item xs={12}>
                  <FormControl>
                    <FormLabel>
                      Sub Contractor Name<div style={{ color: "red" }}>*</div>
                    </FormLabel>
                    <Input
                      value={name}
                      size="sm"
                      placeholder="Sub Contractor Name"
                      onChange={e => setName(e.target.value)}
                    />
                  </FormControl>
                </Grid>
                <br />
              </Grid>

              <Grid item xs={12}>
                <FormLabel style={{ marginBottom: 10 }}>Scope Of Work</FormLabel>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                  <InputTextarea
                    className="p-inputtext-sm PrimeSmallInput"
                    value={scopeOfWork}
                    onChange={e => setScopeOfWork(e.target.value)}
                    rows={5}
                    cols={30}
                    placeholder="Please enter scope of work"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <MultiDropdownApi
                  apiPath="appointments"
                  optionLabel="name"
                  optionValue="id"
                  label="Appointment"
                  selectedData={appointment}
                  setSelectedData={setAppointment}
                />
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Registration">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>VAT Registration Number</FormLabel>
                  <Input
                    value={vatRegistration}
                    size="sm"
                    placeholder="VAT Number"
                    onChange={e => setVatRegistration(e.target.value)}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Company Registration Number</FormLabel>
                  <Input
                    value={companyRegistration}
                    size="sm"
                    placeholder="Registration Number"
                    onChange={e => setCompanyRegistration(e.target.value)}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl>
                  <FormLabel>
                    Compensation Fund Registration Number (Letter of Good Standing)
                  </FormLabel>
                  <Input
                    size="sm"
                    placeholder="Registration Number"
                    value={fundRegistration}
                    onChange={e => setFundRegistration(e.target.value)}
                    onBlur={LogsVerifyID}
                    endDecorator={
                      fundIdLoader ? (
                        <InputIcon className="pi pi-spin pi-spinner" />
                      ) : !fundShowValidation ? (
                        ""
                      ) : fundIdError ? (
                        <InputIcon className="pi pi-times-circle" style={{ color: "red" }} />
                      ) : (
                        <InputIcon className="pi pi-verified" style={{ color: "green" }} />
                      )
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            <br />
            {fundIdError || !certificateNumber ? (
              ""
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Certificate Number</FormLabel>
                    <Input
                      value={certificateNumber}
                      size="sm"
                      placeholder="Certificate Number"
                      readOnly
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Trade Name</FormLabel>
                    <Input value={tradeName} size="sm" placeholder="Trade Name" readOnly />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Issue Date</FormLabel>
                    <Input value={issueDate} size="sm" placeholder="Issue Date" readOnly />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Expiry Date</FormLabel>
                    <Input value={expiryDate} size="sm" placeholder="Expiry Date" readOnly />
                  </FormControl>
                </Grid>
              </Grid>
            )}
          </Card>
        </TabPanel>
        <TabPanel header="CEO/CEO Assistant">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Name</FormLabel>
                  <InputText
                    value={ceoName}
                    onChange={e => setCeoName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter name"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Surname</FormLabel>
                  <InputText
                    value={ceoSurname}
                    onChange={e => setCeoSurname(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter surname"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Contact number</FormLabel>
                  <PhoneInput
                    defaultCountry="za"
                    value={ceoMobile}
                    style={{ width: "100%" }}
                    onChange={e => setCeoMobile(e)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ flexGrow: 1 }}>
                  <FormLabel>
                    Email<div style={{ color: "red" }}>*</div>
                  </FormLabel>
                  <Input
                    size="sm"
                    type="email"
                    startDecorator={<EmailRoundedIcon />}
                    placeholder="email"
                    value={ceoEmail}
                    onChange={e => setCeoEmail(e.target.value)}
                    sx={{ flexGrow: 1 }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Manager">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Name</FormLabel>
                  <InputText
                    value={managerName}
                    onChange={e => setManagerName(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter name"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                  <FormLabel style={{ marginBottom: 10 }}>Surname</FormLabel>
                  <InputText
                    value={managerSurname}
                    onChange={e => setManagerSurname(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                    placeholder="Please enter surname"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Contact number</FormLabel>
                  <PhoneInput
                    defaultCountry="za"
                    value={managerMobile}
                    style={{ width: "100%" }}
                    onChange={e => setManagerMobile(e)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ flexGrow: 1 }}>
                  <FormLabel>
                    Email<div style={{ color: "red" }}>*</div>
                  </FormLabel>
                  <Input
                    size="sm"
                    type="email"
                    startDecorator={<EmailRoundedIcon />}
                    placeholder="email"
                    value={managerEmail}
                    onChange={e => setManagerEmail(e.target.value)}
                    sx={{ flexGrow: 1 }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Sites">
          <SubContractorSiteTable
            globalLoader={props.globalLoader}
            breadcrumbs={props.breadcrumbs}
            session={props.session}
            setBreadcrumbs={props.setBreadcrumbs}
            setGlobalLoader={props.setGlobalLoader}
            setSession={props.setSession}
            accessLevel={props.accessLevel}
            subContractor={subContractor}
            setAccessLevel={props.setAccessLevel}
            setSubContractor={props.setSubContractor}
          />
        </TabPanel>
        {/* <TabPanel header="Badge">
          <EmployeeQrCode label={`${name} ${surname}`} value="https://main.durzblci797ez.amplifyapp.com" image={photoGuid ? `https://cdn.openitem.app/?url=https://accesscontrol.openitemapp.com/Photos/Image?photoguid=${photoGuid}` : photo} />
        </TabPanel> */}
        <TabPanel header="Documents">
          <S3DocumentsUpload
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            type="subcontractor"
            props={props}
          />
        </TabPanel>
      </TabView>

      <Toast ref={toast} />
    </Fragment>
  );
}
